import { transition } from '@helpers/animate';
import { aspectRatio, imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import { headingStyles } from '@helpers/typography';
import styled from 'styled-components';
import MediaEmbed from '../Misc/MediaEmbed/MediaEmbed';
import SectionWrapperStyles from '../SectionWrapper/SectionWrapper.styles';
const Container = styled.div `
  display: grid;
  grid-template-rows: subgrid;
  gap: 0;
  grid-row: span 2;
  color: ${brand.black};
  text-decoration: none;

  a& {
    &:focus-visible {
      outline: auto;
      outline-offset: 3px;
      outline-width: 2px;
      outline-style: solid;
    }
  }
`;
const ImageWrapper = styled.div `
  ${imageWrapperPreserveRatio(1, 1)};

  @media ${from(Device.Tablet)} {
    padding-bottom: ${aspectRatio(836, 454)}%;
  }
`;
const Image = styled.img `
  ${imageCoverContainer()};
`;
const TitleWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: ${fluid(8, 16)} 16px ${fluid(12, 22)};
  background-color: ${brand.white};
`;
const Title = styled.h3 `
  ${headingStyles};
  ${transition('text-decoration-color')};

  font-size: ${fluid(20, 36)};
  line-height: ${fluid(24, 42)};
  text-align: center;
  text-decoration: underline;
  text-underline-position: under;
  text-decoration-color: transparent;
  margin: 0;

  a:focus-visible &,
  a:hover & {
    text-decoration-color: ${brand.green};
  }
`;
const MediaEmbedWrapper = styled(MediaEmbed) `
  margin: 0;

  ${SectionWrapperStyles.Inner} {
    width: 100%;
    margin: 0;
    padding: 0;
  }
`;
const CategoryCardStyles = {
    Container,
    Image,
    ImageWrapper,
    MediaEmbedWrapper,
    Title,
    TitleWrapper,
};
export default CategoryCardStyles;
